import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-021cefa5")

_pushScopeId("data-v-021cefa5")
const _hoisted_1 = { class: "d-flex justify-content-between align-items-center w-100" }
const _hoisted_2 = { class: "flex-grow-1" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "mt-1" }
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_7 = { class: "text-muted" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_VDPopupListbox = _resolveComponent("VDPopupListbox")!

  return (_openBlock(), _createBlock(_component_VDPopupListbox, {
    ref: "listbox",
    dataKey: ['profileId'],
    disabled: _ctx.disabled,
    onOptionAdded: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('profileSelected', $event))),
    disabledOptions: _ctx.addedProfiles,
    filterFields: ['name'],
    isLoading: _ctx.loading,
    groupedOptions: _ctx.groupedProfiles
  }, {
    default: _withId(({ option }) => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(option.name), 1),
          _createVNode("div", _hoisted_4, [
            _createVNode("small", _hoisted_5, _toDisplayString(option.roles?.length || 0) + " " + _toDisplayString(option.roles?.length === 1 ? "rolle" : "roller"), 1)
          ]),
          (option.description)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("small", _hoisted_7, _toDisplayString(option.description), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["disabled", "disabledOptions", "isLoading", "groupedOptions"]))
})